/**
 * Parks the Premium Quote wizard outside Swagger remounts, then places it
 * after Authorize (.scheme-container) and before Default operations.
 * Instruction used: scope-discipline.instructions.md
 */

export const WIZARD_ANCHOR_ID = 'premium-quote-wizard-anchor'

export function restorePremiumQuoteWizardAnchor(section) {
  const anchor = document.getElementById(WIZARD_ANCHOR_ID)
  const container = document.getElementById('swagger-ui-container')
  if (!anchor || !container || !section) return
  if (anchor.parentNode !== section || anchor.nextSibling !== container) {
    section.insertBefore(anchor, container)
  }
}

export function placePremiumQuoteWizardAnchor(swaggerRoot) {
  const anchor = document.getElementById(WIZARD_ANCHOR_ID)
  if (!anchor || !swaggerRoot) return false

  const scheme = swaggerRoot.querySelector('.scheme-container')
  if (!scheme || !scheme.parentNode) return false
  if (scheme.nextSibling !== anchor) {
    scheme.parentNode.insertBefore(anchor, scheme.nextSibling)
  }
  return true
}

export function startPremiumQuoteWizardPlacement(swaggerRoot) {
  if (!document.getElementById(WIZARD_ANCHOR_ID)) return
  if (placePremiumQuoteWizardAnchor(swaggerRoot)) return
  if (!swaggerRoot || swaggerRoot.dataset.heliaWizardPlaceObserver === 'true') return
  swaggerRoot.dataset.heliaWizardPlaceObserver = 'true'
  const observer = new MutationObserver(function () {
    if (placePremiumQuoteWizardAnchor(swaggerRoot)) {
      observer.disconnect()
      swaggerRoot.dataset.heliaWizardPlaceObserver = 'false'
    }
  })
  observer.observe(swaggerRoot, { childList: true, subtree: true })
}
